import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Features from "@/components/home/Features";
import Comparison from "@/components/home/Comparison";
import FamilyMoments from "@/components/home/FamilyMoments";
import WavTeaser from "@/components/home/WavTeaser";
import Manifesto from "@/components/home/Manifesto";
import Testimonials from "@/components/home/Testimonials";
import { SITE } from "@/lib/site";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "InternetServiceProvider",
  name: "CYAN Wireless",
  image: "https://www.cyanwireless.net/brand/logo.png",
  "@id": "https://www.cyanwireless.net/#business",
  url: "https://www.cyanwireless.net/",
  telephone: "+1-970-440-3178",
  email: "support@cyanwireless.net",
  priceRange: "$$",
  description:
    "Locally owned, fast and reliable wireless internet for homes and businesses in Cortez, Dolores, Yellow Jacket and Lewis, Colorado, with unlimited data, no contracts and 5-star support.",
  areaServed: ["Cortez CO", "Dolores CO", "Yellow Jacket CO", "Lewis CO"],
  address: { "@type": "PostalAddress", addressRegion: "CO", addressCountry: "US" },
  openingHoursSpecification: [
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "09:00", closes: "17:00" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Saturday"], opens: "10:00", closes: "14:00" },
  ],
  aggregateRating: { "@type": "AggregateRating", ratingValue: "5", reviewCount: "40" },
};

export default function Home() {
  return (
    <>
      <Seo
        title="High-Speed Rural Internet in Cortez, Dolores & Yellow Jacket, CO | CYAN Wireless"
        description="Blazing-fast rural internet from CYAN Wireless. No contracts, unlimited data, fast speeds and 5-star local support in Cortez, Dolores, Yellow Jacket & Lewis, Colorado. Check availability today!"
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <EditorialMarquee />
      <FamilyMoments />
      <Features />
      <Comparison />
      <WavTeaser />
      <Manifesto />
      <Testimonials />
    </>
  );
}
